import PropTypes from "prop-types";
import Breakdown from "./Breakdown";
import Filter from "./Filter";

function Control({
  loading,
  setCache,
  setShowConfig,
  setInitState,
  onRefreshReport,
}) {
  return (
    <>
      <div className="filters hidden md:flex md:justify-between flex-wrap mx-1">
        <Breakdown />
        <Filter
          setCache={setCache}
          onRefreshReport={onRefreshReport}
          loading={loading}
          setShowConfig={setShowConfig}
          setInitState={setInitState}
        />
      </div>
    </>
  );
}

Control.propTypes = {
  filterClass: PropTypes.string,
  state: PropTypes.object,
  breakdownChange: PropTypes.func,
  platformChange: PropTypes.func,
  adPlacementChange: PropTypes.func,
  dateChange: PropTypes.func,
};

export default Control;
